module.exports = __webpack_public_path__ + "static/media/how-it-works.f6c25e85.md";